import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  organizationZoneCreate,
  organizationZoneDelete,
  organizationZoneFind,
  organizationZoneRecord,
  organizationZoneStatus,
  organizationZoneUpdate,
} from "../../../api/organizationZone_api";
import { animateCss } from "../../../pages/TosterAlert";

export const organizationZoneRecordAction = createAsyncThunk(
  "organizationZone/record",
  async (values, { rejectWithValue, getState }) => {
    try {
      const checklist = await organizationZoneRecord(values);
      return checklist;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationZoneFindAction = createAsyncThunk(
  "organizationZone/FindZone",
  async (values, { rejectWithValue, getState }) => {
    try {
      const checklist = await organizationZoneFind(values);
      return checklist;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationZoneCreateAction = createAsyncThunk(
  "organizationZone/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await organizationZoneCreate(payload);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to create zone",
        details: error.details || null,
      });
    }
  }
);

export const organizationZoneUpdateAction = createAsyncThunk(
  "organizationZone/update",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await organizationZoneUpdate(payload);

      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to update zone",
        details: error.details || null,
      });
    }
  }
);

export const organizationZoneStatusAction = createAsyncThunk(
  "organizationZone/status",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await organizationZoneStatus(payload);

      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to update zone",
        details: error.details || null,
      });
    }
  }
);

export const organizationZoneDeleteAction = createAsyncThunk(
  "organizationZone/delete",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await organizationZoneDelete(payload);

      if (response.success) {
        animateCss(
          "success",
          response.message || "Zone deleted successfully",
          3000
        );
      } else {
        animateCss("error", response.message || "Zone not deleted ", 3000);
      }

      return response;
    } catch (error) {
      const alertType = error.response?.status === 400 ? "warn" : "error";
      const message = error.response?.message || "Failed to delete zone";

      animateCss(alertType, message, 1000);

      return rejectWithValue({
        message,
        status: error.response?.status,
        details: error.response?.data?.details || null,
      });
    }
  }
);
